import { render, staticRenderFns } from "./HighEndArchives.vue?vue&type=template&id=4e54cdee&scoped=true&"
import script from "./HighEndArchives.vue?vue&type=script&lang=js&"
export * from "./HighEndArchives.vue?vue&type=script&lang=js&"
import style0 from "./HighEndArchives.vue?vue&type=style&index=0&id=4e54cdee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e54cdee",
  null
  
)

export default component.exports